import axios from 'axios';

let API = process.env.REACT_APP_BACKENDS_PRODUCTS_URL;
if (!API) {
    API = 'https://product.swisskischool.ch';
}

const axiosapi = axios.create({
    baseURL: API,
    timeout: 40000,
    headers: { 'Content-Type': 'application/json' },
});

export default axiosapi;
